import { IAwsSetting } from "src/core/shared/api/globalSettings.api";

/**
 * Generates an S3 URL from the give config
 */
export const configToS3BucketUrl = (config?: IAwsSetting): string | undefined => {
  const bucket = config?.s3.bucket;
  const region = config?.s3.region;

  return bucket && region ? `https://${bucket}.s3.${region}.amazonaws.com` : undefined;
};